import CopyWithInterpolatedLink from './CopyWithInterpolatedLink';

export default CopyWithInterpolatedLink;
